<template>
    <div>
        <!-- Posicionar no mapa o endereço do aluno: arraste o pino ou clique no ponto. A coordenada é obrigatória
             (config/geo.php da API) e nunca aproximada — por isso o botão só libera com o pino posicionado. -->
        <el-alert v-if="motivo" :title="motivo" type="warning" show-icon :closable="false" style="margin-bottom: 10px;"></el-alert>

        <div style="margin-bottom: 8px;">
            <b>Endereço:</b> {{ endereco || '—' }}
            <br><small style="color: #909399;">Arraste o pino (ou clique no mapa) até a casa do aluno e confirme.</small>
        </div>

        <div v-if="!temChave" class="mapa-indisponivel">
            <b>Mapa indisponível.</b> Cadastre a chave da API do Google Maps em <b>Configurações Gerais</b> para posicionar o endereço.
        </div>

        <GmapMap v-else ref="mapa" :center="centro" :zoom="zoom" :options="opcoes" class="mapa-endereco" @click="mover($event.latLng)">
            <GmapMarker v-if="pino" :position="pino" :draggable="true" @dragend="mover($event.latLng)"></GmapMarker>
        </GmapMap>

        <div style="margin-top: 6px; font-size: 12px; color: #606266;">
            <template v-if="pino">Pino em {{ pino.lat.toFixed(6) }}, {{ pino.lng.toFixed(6) }}</template>
            <template v-else>Clique no mapa para colocar o pino.</template>
        </div>

        <div class="u-text-right u-mt-10">
            <el-button @click="$emit('cancelar')">Cancelar</el-button>
            <el-button type="primary" :disabled="!pino" @click="$emit('confirmar', { lat: pino.lat, lng: pino.lng })">Confirmar localização</el-button>
        </div>
    </div>
</template>
<script>
export default {
    // sugestao: {lat, lng} para centrar (resultado aproximado, ficha da SED, escola ou município); posicionado: já tem pino?
    props: ['endereco', 'motivo', 'sugestao', 'posicionado'],
    data: () => ({
        pino: null,
        centro: { lat: -22.4764, lng: -46.6336 },
        zoom: 16,
        opcoes: { mapTypeId: 'roadmap', streetViewControl: false, fullscreenControl: true, mapTypeControl: true, clickableIcons: false }
    }),
    computed: {
        temChave() { return !!(this.$googleMapsKey || (typeof window !== 'undefined' && window.__GOOGLE_MAPS_KEY__)); }
    },
    mounted() {
        if (this.sugestao && this.sugestao.lat && this.sugestao.lng) {
            this.centro = { lat: Number(this.sugestao.lat), lng: Number(this.sugestao.lng) };
            // Sugestão vinda de coordenada já existente: começa com o pino nela; aproximada: só centra, o usuário coloca.
            if (this.posicionado) this.pino = { ...this.centro };
            this.zoom = this.posicionado ? 17 : 15;
        } else {
            this.zoom = 13;
        }
    },
    methods: {
        mover(latLng) {
            if (!latLng) return;
            this.pino = { lat: latLng.lat(), lng: latLng.lng() };
        }
    }
}
</script>
<style scoped>
.mapa-endereco { width: 100%; height: 440px; }
.mapa-indisponivel { border: 1px dashed #dcdfe6; border-radius: 4px; padding: 30px; text-align: center; color: #909399; }
</style>
